import type { GridTuning } from "@/character/draft";
import { parseCharacterSpritesheet } from "@/character/spritesheet";
import { consumeShadowCreateCard, type HomeEconomy } from "@/home/economy";
import { newShadowId } from "@/shadow/firestore-storage";
import { emptyShadowAllocation, type ShadowDefinition, type ShadowPlayerState } from "@/shadow/types";

export type AppendShadowFromSheetResult =
  | { ok: true; state: ShadowPlayerState; economy: HomeEconomy; shadow: ShadowDefinition }
  | { ok: false; reason: string };

export async function appendShadowFromSpritesheet(
  state: ShadowPlayerState,
  economy: HomeEconomy,
  input: { name: string; sheetDataUrl: string; gridTuning: GridTuning },
): Promise<AppendShadowFromSheetResult> {
  if (economy.shadowCreateCards < 1) {
    return { ok: false, reason: "ไม่มีบัตรสร้างร่างเงา" };
  }
  const trimmed = input.name.trim() || "ร่างเงา";
  try {
    const parsed = await parseCharacterSpritesheet(input.sheetDataUrl, input.gridTuning);
    const nextEco = consumeShadowCreateCard(economy);
    if (!nextEco) {
      return { ok: false, reason: "ไม่มีบัตรสร้างร่างเงา" };
    }
    const shadow: ShadowDefinition = {
      id: newShadowId(),
      name: trimmed.slice(0, 48),
      createdAt: Date.now(),
      spritesheetDataUrl: parsed.spritesheetDataUrl,
      grid: parsed.grid,
      actions: parsed.actions,
      apCardsApplied: 0,
      statAllocation: emptyShadowAllocation(),
    };
    return {
      ok: true,
      state: { ...state, shadows: [...state.shadows, shadow] },
      economy: nextEco,
      shadow,
    };
  } catch (e) {
    return {
      ok: false,
      reason: e instanceof Error ? e.message : "สร้างร่างเงาไม่สำเร็จ",
    };
  }
}
